
import React from 'react';
import { DynamicSeoHead } from './DynamicSeoHead';
import { generateSearchSeoTitle, generateSearchSeoDescription, createSearchStructuredData } from '@/utils/searchSeoUtils';

interface SearchSeoHeadProps {
  query?: string;
  categoryName?: string;
  categoryId?: string;
  location?: string;
  minPrice?: number;
  maxPrice?: number;
  resultsCount?: number;
  sortBy?: string;
  filters?: {
    make?: string;
    minYear?: number;
    maxYear?: number;
    condition?: string;
    transportOption?: string;
  };
}

export const SearchSeoHead: React.FC<SearchSeoHeadProps> = ({
  query,
  categoryName,
  categoryId,
  location,
  minPrice,
  maxPrice,
  resultsCount = 0,
  sortBy,
  filters = {}
}) => {
  const title = generateSearchSeoTitle({
    query,
    categoryName,
    location,
    minPrice,
    maxPrice,
    sortBy,
    filters
  });

  const description = generateSearchSeoDescription({
    query,
    categoryName,
    location,
    minPrice,
    maxPrice,
    resultsCount,
    filters
  });

  const structuredData = createSearchStructuredData({
    query,
    categoryName,
    location,
    resultsCount
  });

  // Generate current URL
  const currentUrl = typeof window !== 'undefined' ? window.location.href : 'https://treguim.org/search';

  // Generate dynamic keywords
  const keywords = [
    query,
    categoryName,
    location,
    'blej online',
    'shit online',
    'treguim',
    'shpallje falas',
    'produkte online',
    filters.make,
    filters.condition === 'new' ? 'i ri' : 'i perdorur'
  ].filter(Boolean).join(', ');

  return (
    <DynamicSeoHead
      title={title}
      description={description}
      keywords={keywords}
      ogType="website"
      url={currentUrl}
      structuredData={structuredData}
      entityName={query || categoryName}
      category={categoryName}
      location={location}
      price={minPrice}
      condition={filters.condition}
    />
  );
};
